import React from 'react';
import classnames from 'classnames';
import ReactSVG from 'react-svg';
import MerlinSurveyAssistant from "./merlin/MerlinSurveyAssistant";
import SocialActions from "./social/SocialActions";

const Header = ({appIsLoading, className, onActionCompleted, page, processingNavigation}) => {
  const cssBem = 'header';
  const classes = classnames(cssBem, className);

  return <header className={classes}>
    <div className="container">
      <div className={`${cssBem}__logo`}>
        <ReactSVG src="/classpath/assets/images/logo.svg" />
      </div>

      {/* { !appIsLoading ? <MerlinSurveyAssistant
        currentPage={page}
        onActionCompleted={onActionCompleted}
        processingNavigation={processingNavigation}
      /> : null } */}
      { !appIsLoading ? <SocialActions onActionCompleted={onActionCompleted}/> : null }

    </div>
  </header>;
};

export default Header;
